/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { store } from './stores/store';
import '@shopify/polaris/build/esm/styles.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-multi-carousel/lib/styles.css';

import './index.css';
import './styles/global.css';
import App from './App';
import history from 'src/routes/history';
import * as Sentry from '@sentry/react';
import { initFullStory } from 'src/integrations/fullStory';

const sentryDns =
  process.env.REACT_APP_SENTRY_DNS ||
  'https://ae3a2895dd9d44e4b7d333cc620997bf@sentry.boost-wp.com/2';
Sentry.init({
  dsn: sentryDns,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

initFullStory();

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);
